import avatar from 'assets/img/team/avatar.png';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Row, Card, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import * as accessControlObj from '../../authentication/accessControlMap'
import axios from 'helpers/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PatientVitals from './PatientVitals';
import PatientVitalHistoryPanel from './PatientVitalHistoryPanel';
import DayProgramModal from './DayProgramModal';
import SharedLivingModal from './SharedLivingModal';
import { isSharedLivingActive } from 'helpers/isSharedLivingActive';
import { isSharedLivingPatient } from 'helpers/isSharedLivingFacility';


const PatientDetailsHeader = (props) => {

    //console.log("patientDetailsName" + props.username + props.facilityid + props.facility_name + props.patientid);
    const [mymActive, setMymActive] = useState(false);
    const [latestVitals, setLatestVitals] = useState([]);
    const [showVitalsModal, setShowVitalsModal] = useState(false);
    const [showVitalHistoryModal, setShowVitalHistoryModal] = useState(false);
    const [selectedHistoryVital, setSelectedHistoryVital] = useState(null);
    const [showDayPrograms, setShowDayPrograms] = useState(false);
    const [showCaregivers, setShowCaregivers] = useState(false);
    const objData = props.paramsObj
    const [dayProgramData, setDayProgramData] = useState(objData.day_programs);
    const [caregiverData, setCaregiverData] = useState(objData.athome_caregivers || []);
    const pname = props.patient_name
    const sharedLivingActive = isSharedLivingActive();
    const currentRoleId = Number(localStorage.getItem("roleId"));
    let localStorageAccessControl = localStorage.getItem("accessControl");
    let roleId = Number(localStorage.getItem("roleId"))
    const dayprogramActive = localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["dayprogramactive"])

    useEffect(() => {
        if (localStorageAccessControl.includes(accessControlObj.ACCESS_CONTROL["mym"])) {
            setMymActive(true);
        }
    });

    useEffect(() => {
        fetchLatestVitals();

        const refreshHeaderVitals = event => {
            if (!event.detail?.patientid || Number(event.detail.patientid) === Number(objData?.id)) {
                fetchLatestVitals();
            }
        };

        window.addEventListener('patientVitalsUpdated', refreshHeaderVitals);
        return () => window.removeEventListener('patientVitalsUpdated', refreshHeaderVitals);
    }, [objData?.id]);

    const fetchLatestVitals = async () => {
        if (!objData?.id) return;

        try {
            const tokenStr = localStorage.getItem("accessToken");
            const { data } = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/patients/vital-readings/latest/${objData.id}`,
                { headers: { 'Authorization': `Bearer ${tokenStr}` } }
            );
            setLatestVitals(data?.data || []);
        } catch (error) {
            setLatestVitals([]);
        }
    };

    const formatVitalValue = vital => {
        if (!vital || vital.reading_id === null) return '-';
        if (vital.data_type === 'text') return vital.text_value || vital.value_1 || '-';
        if (vital.data_type === 'dual') {
            return [vital.value_1, vital.value_2].filter(Boolean).join('/');
        }
        return vital.value_1 ?? '-';
    };

    const hasVitalValue = vital => {
        const val = formatVitalValue(vital);
        return val !== null && val !== undefined && val !== '-' && val !== '';
    };
    const fetchVitalHistory = vital => {
        if (!objData?.id || !vital?.vital_sign_id) return;

        setSelectedHistoryVital(vital);
        setShowVitalHistoryModal(true);
    };

    const manageDayPrograms = () => {
        setShowDayPrograms(true);
    }

    return (
        <Card>
            <DayProgramModal
                show={showDayPrograms}
                onHide={() => setShowDayPrograms(false)}
                patientId={objData.id}
                patientName={pname}
                day_programs={dayProgramData}
                setDayProgramData={setDayProgramData}
            />
            <SharedLivingModal
                show={showCaregivers}
                onHide={() => setShowCaregivers(false)}
                patientId={objData.id}
                patientName={pname}
                setCaregiverData={setCaregiverData}
            />
            <Card.Header className="pb-0 pt-4 mb-2">
                <h4 className="mb-1">
                    {props.patient_name}
                </h4>
            </Card.Header>
            <Card.Body className="py-0">
                <Row>
                    <Col lg={7}>
                        <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Allergies: <span className='text-danger'>{objData?.allergies_text}</span></h6>
                            </div>
                        </Flex>
                        {latestVitals.filter(hasVitalValue).length > 0 && (
                            <Flex alignItems="start" className="mb-2">
                                <div className="flex-1">
                                    <h6 className="mb-1">Current Vitals</h6>
                                    <div className="d-flex flex-wrap gap-2">
                                        {latestVitals.filter(hasVitalValue).map(vital => (
                                            <span
                                                key={vital.vital_sign_id}
                                                role="button"
                                                tabIndex={0}
                                                className="d-inline-flex align-items-center gap-1 fs-11 text-700 border rounded px-2 py-1 bg-100 cursor-pointer"
                                                title={`View ${vital.name} history`}
                                                onClick={() => mymActive && (roleId < 7) && fetchVitalHistory(vital)}
                                                onKeyDown={event => {
                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                        fetchVitalHistory(vital);
                                                    }
                                                }}
                                            >
                                                <span className="fw-semibold">{vital.short_name || vital.name}:</span>
                                                <span className={(vital.is_out_of_range) === 1 ? 'text-danger' : ''}>{formatVitalValue(vital)}</span>
                                                {vital.unit && <span className= {(vital.is_out_of_range) === 1 ? 'text-danger':'text-500'}>{vital.unit}</span>}
                                                {/* {Number(vital.is_out_of_range) === 1 && (
                                                    <Badge bg="danger" className="ms-1">Alert</Badge>
                                                )} */}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </Flex>
                        )}
                    </Col>
                    <Col lg={4} className="ps-2 ps-lg-3 me-0 ms-auto">
                        <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Facility Name: {objData.facility_name} </h6>
                            </div>
                        </Flex>
                        <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Group Name: {objData.group_name}</h6>
                            </div>
                        </Flex>
                        {dayprogramActive && <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Assigned Day Programs: {dayProgramData?.length > 0 ? dayProgramData?.map((program) => program.name).join(', ') : 'No day programs assigned'}</h6>
                            </div>
                        </Flex>}
                        {sharedLivingActive && <Flex alignItems="center" className="mb-2">
                            <div className="flex-1">
                                <h6 className="mb-0">Caregivers: {caregiverData?.length > 0 ? caregiverData?.map((c) => `${c.first_name || ''} ${c.last_name || ''}`.trim() || c.username).join(', ') : 'No caregivers assigned'}</h6>
                            </div>
                        </Flex>}
                        {/* UI-069 (refined): nurse + case-manager inline with the other staffing rows
                            instead of in a separate overlapping card. Stale (is_active = 0) state
                            is surfaced as a compact "(Inactive)" suffix. */}
                        {isSharedLivingPatient(objData) && objData.nurse && (() => {
                            const n = objData.nurse;
                            const name = `${n.first_name || ''} ${n.last_name || ''}`.trim() || `User #${n.id}`;
                            const inactive = !(n.is_active === 1 || n.is_active === '1' || n.is_active === true);
                            return (
                                <Flex alignItems="center" className="mb-2">
                                    <div className="flex-1">
                                        <h6 className="mb-0">
                                            Nurse: {name}
                                            {inactive && <span className="text-warning ms-1">(Inactive)</span>}
                                            {n.phone && (
                                                <a href={`tel:${n.phone}`} className="ms-2 fs-11 text-decoration-none">
                                                    {n.phone}
                                                </a>
                                            )}
                                        </h6>
                                    </div>
                                </Flex>
                            );
                        })()}
                        {isSharedLivingPatient(objData) && objData.case_manager && (() => {
                            const c = objData.case_manager;
                            const name = `${c.first_name || ''} ${c.last_name || ''}`.trim() || `User #${c.id}`;
                            const inactive = !(c.is_active === 1 || c.is_active === '1' || c.is_active === true);
                            return (
                                <Flex alignItems="center" className="mb-2">
                                    <div className="flex-1">
                                        <h6 className="mb-0">
                                            Case Manager: {name}
                                            {inactive && <span className="text-warning ms-1">(Inactive)</span>}
                                            {c.phone && (
                                                <a href={`tel:${c.phone}`} className="ms-2 fs-11 text-decoration-none">
                                                    {c.phone}
                                                </a>
                                            )}
                                        </h6>
                                    </div>
                                </Flex>
                            );
                        })()}
                    </Col>

                    <Row className="col-12 mx-0 w-100 avatar-profile-sec">
                        <Avatar
                            size='5xl'
                            className="avatar-profile col-1 mx-0 px-0 cursor-pointer"
                            src={objData.profile_image ? objData.profile_image : avatar}
                            mediaClass="img-thumbnail shadow-sm"
                            flag={true}
                        />
                        <Col lg={10} className="border-top px-0 py-2 mt-3 ms-auto me-0 text-end">
                            <div className='d-inline mx-2 h6'>
                                <Link
                                    // variant="link"
                                    className="p-0 text-decoration-none fw-semibold align-baseline"
                                    onClick={() => setShowVitalsModal(true)}
                                >
                                    <FontAwesomeIcon icon="stethoscope" className="me-1" />
                                    Patient Vitals
                                </Link>
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {mymActive &&
                                    (Number(localStorage.getItem("roleId")) == 4) && dayprogramActive &&
                                    <Link state={{
                                        day_programs: objData.day_programs,
                                    }}>
                                        <Button size='sm' variant='outline' onClick={manageDayPrograms}>
                                            Manage Day Programs
                                        </Button>
                                    </Link>
                                }
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {currentRoleId <= 4 && sharedLivingActive &&
                                    <Button size='sm' variant='outline' onClick={() => setShowCaregivers(true)}>
                                        Manage Caregivers
                                    </Button>
                                }
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {mymActive && (roleId < 7) &&
                                    <Link to={{ pathname: paths.addPrescription }} state={{
                                        facilityname: objData.facility_name,
                                        patientid: objData.id,
                                        orderid: null,
                                        patientname: props.patient_name
                                    }} className='text-primary'>Add Prescription</Link>}
                            </div>
                            <div className='d-inline mx-2 h6'>
                                {mymActive && (roleId < 7) &&
                                    <Link to={{ pathname: paths.addMedicalRecord }} state={{
                                        facilityid: objData.facility_id,
                                        patientid: objData.id,
                                        medrecord_id: null
                                    }} className='text-success' >Add Medical Record</Link>}
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Card.Body>
            <Modal
                show={showVitalsModal}
                onHide={() => setShowVitalsModal(false)}
                size="xl"
                scrollable
                fullscreen="lg-down"
                centered
                className="patient-vitals-modal"
            >
                <Modal.Header closeButton className="bg-body-tertiary">
                    <Modal.Title className="d-flex align-items-center gap-2 fs-8">
                        <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                            style={{ width: 34, height: 34 }}
                        >
                            <FontAwesomeIcon icon="stethoscope" className="fs-9" />
                        </span>
                        Patient Vitals
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-100 hide-scrollbar">
                    <div className="mb-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
                        <div>
                            <h5 className="mb-1">{props.patient_name}</h5>
                            <div className="fs-11 text-600">
                                {objData.facility_name} {objData.group_name ? `- ${objData.group_name}` : ''}
                            </div>
                        </div>
                        {/* <div className="d-flex flex-wrap gap-2">
                            {latestVitals.slice(0, 4).map(vital => (
                                <span
                                    key={vital.vital_sign_id}
                                    className="d-inline-flex align-items-center gap-1 fs-11 text-700 border rounded px-2 py-1 bg-white"
                                >
                                    <span className="fw-semibold">{vital.short_name || vital.name}:</span>
                                    <span>{formatVitalValue(vital)}</span>
                                    {Number(vital.is_out_of_range) === 1 && (
                                        <Badge bg="danger" className="ms-1">Alert</Badge>
                                    )}
                                </span>
                            ))}
                        </div> */}
                    </div>
                    <PatientVitals patientid={objData.id} data={objData} />
                </Modal.Body>
            </Modal>
            <Modal
                show={showVitalHistoryModal}
                onHide={() => setShowVitalHistoryModal(false)}
                size="xl"
                centered
                scrollable
                fullscreen="lg-down"
                className="patient-vitals-modal"
            >
                <Modal.Header closeButton className="bg-body-tertiary">
                    <Modal.Title className="d-flex align-items-center gap-2 fs-8">
                        <span
                            className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                            style={{ width: 34, height: 34 }}
                        >
                            <FontAwesomeIcon icon="stethoscope" className="fs-9" />
                        </span>
                        {selectedHistoryVital?.name || 'Vital'} History
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-100 hide-scrollbar">
                    {selectedHistoryVital && (
                        <PatientVitalHistoryPanel
                            patientId={objData.id}
                            vital={selectedHistoryVital}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </Card>
    );
};

export default PatientDetailsHeader;
